import React from "react";

import { t } from "i18next";

export function Ignore(props: any): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 350 87"
        >
            <g
                id="Groupe_15"
                data-name="Groupe 15"
                transform="translate(-1482 4082)"
            >
                <g
                    id="Rectangle_11"
                    data-name="Rectangle 11"
                    transform="translate(1482 -4082)"
                    fill="#fff"
                    stroke="#000"
                    stroke-width="2"
                >
                    <rect width="350" height="87" rx="9" stroke="none" />
                    <rect
                        x="1"
                        y="1"
                        width="348"
                        height="85"
                        rx="8"
                        fill="none"
                    />
                </g>
                <text
                    id="Ignore"
                    transform="translate(1657 -4024)"
                    fill="#323333"
                    font-size="38"
                    font-family="HelveticaNeue-Medium, Helvetica Neue"
                    font-weight="500"
                >
                    <tspan x="-62.32" y="0">
                        {t("Ignore", {
                            lng: props.selectedLanguage,
                        })}
                    </tspan>
                </text>
            </g>
        </svg>
    );
}
